import { COMPANY_ROUTE } from '@constants'

export const API_PARTNER_LIST_URL = `${COMPANY_ROUTE}partner/`
export const API_PARTNER_DETAILS_URL = `${COMPANY_ROUTE}partner/{partner_id}/`
export const API_PARTNER_CALCULATION_BASE_URL = `${COMPANY_ROUTE}partner/{partner_id}/calculation-base/`
export const API_PARTNER_LIST_EXPORT_URL = `${COMPANY_ROUTE}partner/export/`
export const API_PARTNER_INVOICE_COUNT_URL = `${COMPANY_ROUTE}partner/{partner_id}/invoice-count/`
export const API_PARTNER_MERGE_URL = `${COMPANY_ROUTE}partner/{partner_id}/merge-to/`
